import { FC, useState } from 'react'
import { RenderIf } from 'components/RenderIf'

import { ReactComponent as ClocheIcon } from 'assets/cloches/clocheSquare.svg'

import { IconFilled } from 'components/IconsContainers/styled'
import { ImageContainer, StyledImage } from './styled'
import { useGetTranslatedNames } from 'featureSliced/shared/hooks/useGetTranslatedNames'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

type CartProductType = {
  product?: IProduct
  numberToShow?: number
}

// TODO: rework
export const CartProductImage: FC<CartProductType> = ({
  product,
  numberToShow,
}) => {
  console.log('🚀 ~ product:', product?.imageUrl)
  const color = useMySelector((state) => state.app.interfaceStyles).colour
  const [isImgErrored, setIsImageErrored] = useState(false)
  const { getProductName } = useGetTranslatedNames()

  return (
    <RenderIf condition={Boolean(product)}>
      <ImageContainer count={numberToShow} isSmall={isImgErrored}>
        {/* <StyledImage
          src={product?.imageUrl || 'ERRORED_IMAGE'}
          // onError={({ currentTarget }) => {
          //   setIsImageErrored(true)
          //   currentTarget.onerror = null // prevents looping
          // }}
          // alt={product?.title
          alt={getProductName(product)}
          width="75"
          height="75"
        /> */}
        <RenderIf condition={!isImgErrored}>
          <StyledImage
            src={product?.imageUrl || 'ERRORED_IMAGE'}
            onError={({ currentTarget, ...rest }: any) => {
              console.log('🚀 ~ currentTarget:', currentTarget)
              console.log('🚀 ~ rest:', rest)
              setIsImageErrored(true)
              currentTarget.onerror = null // prevents looping
            }}
            // alt={product?.title}
            alt={getProductName(product)}
            width="75"
            height="75"
          />
        </RenderIf>
        <RenderIf condition={isImgErrored}>
          <IconFilled color={`${color}80`}>
            <ClocheIcon />
          </IconFilled>
        </RenderIf>
      </ImageContainer>
    </RenderIf>
  )
}
